import { render, staticRenderFns } from "./PartnershipCard.vue?vue&type=template&id=5eefdece&scoped=true&"
import script from "./PartnershipCard.vue?vue&type=script&lang=js&"
export * from "./PartnershipCard.vue?vue&type=script&lang=js&"
import style0 from "./PartnershipCard.vue?vue&type=style&index=0&id=5eefdece&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eefdece",
  null
  
)

export default component.exports